import {createApp} from 'vue';
import {createHead, VueHeadMixin} from '@unhead/vue/client';

import App from './App.vue';
import router from './router';
import store from './store';
import 'jquery';
import 'metismenu';
import {createI18n} from 'vue-i18n';
import {fr} from '@lang/fr.js';
import moment from 'moment/moment';
import 'moment/locale/fr';
import FloatingVue, {hideAllPoppers} from 'floating-vue';
import 'floating-vue/dist/style.css';
import {PerfectScrollbarPlugin} from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
/**PrimeVue**/
import PrimeVue from 'primevue/config';
import installDatepickerDismissGuard from '@utils/datepickerDismissGuard';
import VSwatches from 'vue3-swatches';
import 'vue3-swatches/dist/style.css';
import VueLoaders from 'vue-loaders';
import BadgeDirective from 'primevue/badgedirective';
import ToastService from 'primevue/toastservice';

/**LIB**/
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import VuelidatePlugin from '@vuelidate/core';
import {createPinia} from 'pinia';
import VueSplide from '@splidejs/vue-splide';
import {addCustomDomains} from 'mailchecker';
import {VueRecaptchaPlugin} from 'vue-recaptcha';

/** COMPOSANTS **/
import GaReservationSidebar from '@views/reservation/GaReservationSidebar';
import GaCommentSidebar from '@views/accounting/GaCommentSidebar.vue';
import GaView from '@components/layout/GaView';
import GaContentView from '@components/layout/GaContentView';
import GaTabView from '@components/layout/GaTabView';
import Dialog from 'primevue/dialog';
import Sidebar from 'primevue/sidebar';
import Message from 'primevue/message';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import Column from 'primevue/column';
import GaTitleMenu from '@components/ga/general/GaTitleMenu';
import GaItemTitle from '@components/ga/general/GaItemTitle';
import ConfirmationService from 'primevue/confirmationservice';
import GaReservationFilterPlanning from './views/reservation/GaReservationFilterPlanning';
import GaReservationFilterList from './views/reservation/GaReservationFilterList';
import GaAccommodationFilterList from '@views/accommodation/GaAccommodationFilterList.vue';
import GaOperationsConsultationFilterList from '@views/accounting/operations/tabs/GaOperationsConsultationFilterList.vue';
import GaPaymentFilterList from '@views/reservation/GaPaymentFilterList.vue';
import GaThirdPartyAccountFilterList from '@views/accounting/thirdpartyaccount/filter/GaThirdPartyAccountFilterList.vue';
import GaRecapitulatifFacturationFilterList from '@views/accounting/recap/filter/GaRecapitulatifFacturationFilterList.vue';
import GaTransactionsFilterList from '@views/accounting/transactions/filter/GaTransactionsFilterList.vue';
import GaProspectFilterList from '@views/prospect/GaProspectFilterList.vue';
import GaCrgConsultationFilter from './views/accounting/crg/filter/GaCrgConsultationFilter';
import GaCrgListFilter from './views/accounting/crg/filter/GaCrgListFilter';
import GaCrgPaymentFilter from './views/accounting/crg/filter/GaCrgPaymentFilter';
import GaCrgHistoriqueFilter from './views/accounting/crg/filter/GaCrgHistoriqueFilter';
import GaOwnerListFilter from '@views/owner/filter/GaOwnerListFilter.vue';
import GaClientListFilter from '@views/client/filter/GaClientListFilter.vue';
import GaTicketListFilter from '@views/ticket/filter/GaTicketListFilter.vue';
import GaStayRateConsultationFilter from '@views/accounting/stayrates/filter/GaStayRateConsultationFilter.vue';
import GaStayRateTransfertFilter from '@views/accounting/stayrates/filter/GaStayRateTransfertFilter.vue';
import GaCancelFilter from '@views/reservation/GaCancelFilter.vue';
import GaEmployeeListFilter from '@views/employee/filter/GaEmployeeListFilter.vue';
import GaOperationsOwnerChargeFilter from '@views/accounting/operations/filter/GaOperationsOwnerChargeFilter.vue';
import GaParametrageCommissionFilter from '@views/settings/ParametrageCommission/filter/GaParametrageCommissionFilter.vue';
import GaLitigeListFilter from '@views/litige/filter/GaLitigeListFilter.vue';
import GaPartenaireFilterList from '@views/partenaires/GaPartenaireFilterList.vue';
import GaHousekeeperFilterList from '@views/housekeepers/GaHousekeeperFilterList.vue';
import GaPrestataireFilterList from '@views/prestataires/GaPrestataireFilterList.vue';
import GaMandatListFilter from '@views/mandat/filter/GaMandatListFilter.vue';
import GaAvenantListFilter from '@views/mandat/filter/GaAvenantListFilter.vue';
import GaMaintenanceListFilter from '@views/maintenance/filter/GaMaintenanceListFilter.vue';
import GaUpsellListFilter from '@views/upsell/filter/GaUpsellListFilter.vue';
import GaMissionPlanningParticipantFilter from '@views/operationnel/mission/filter/GaMissionPlanningParticipantFilter.vue';
import GaMissionSuiviFilter from '@views/operationnel/missionsuivi/filter/GaMissionSuiviFilter.vue';
import GaWaitingOrdersFilter from '@views/operationnel/waitingorders/filter/GaWaitingOrdersFilter.vue';
import GaAccommodationExtrasFilter from '@views/upsell/filter/GaAccommodationExtrasFilter.vue';
import GaMissionDashboardFilter from '@views/operationnel/missiondashboard/filter/GaMissionDashboardFilter';
import VueMobileDetection from 'vue-mobile-detection';
import GaMissionSuiviPartnerFilter from '@views/operationnel/missionsuivi/filter/GaMissionSuiviPartnerFilter';
import GaMissionOrderListFilter from '@views/operationnel/missionorders/filter/GaMissionOrderListFilter';
import GaCrgOwnerFilter from './views/accounting/crg/filter/GaCrgOwnerFilter.vue';
import GaMissionWaitingOrdersSidebar from '@views/operationnel/waitingorders/sidebar/GaMissionWaitingOrdersSidebar';
import GaMissionPlanningAccommodationFilter from '@views/operationnel/accommodationplanning/filter/GaMissionPlanningAccommodationFilter';
import GaReservationLitigeSidebar from '@views/reservation/sidebar/GaReservationLitigeSidebar';
import GaReservationReclamationSidebar from '@views/reservation/sidebar/GaReservationReclamationSidebar';
import FacturationHoteOperationsSidebarFilter from '@views/accounting/facturationhote2/operations/filter/FacturationHoteOperationsSidebarFilter';
import FacturationHoteConsultationSidebarFilter from '@views/accounting/facturationhote2/consultation/filter/FacturationHoteConsultationSidebarFilter';
import FacturationVoyageurSidebarFilter from '@views/accounting/facturationvoyageur/filter/FacturationVoyageurSidebarFilter';
import GaAccommodationMandatUpdateSidebar from '@views/accommodation/mandat/sidebar/GaAccommodationMandatUpdateSidebar.vue';
import GaAccommodationReservationFilterList from '@views/reservation/filter/GaAccommodationReservationFilterList.vue';
import GaCommercialFilterList from '@views/commercials/filter/GaCommercialFilterList.vue';
import GaContactDetailsSidebar from '@views/contacts/sidebar/GaContactDetailsSidebar.vue';
import GaCrmFilterList from '@views/crm/filter/GaCrmFilterList.vue';
import GaFilterBaseAutocomplete from '@components/v2/filter/sidebarFilters/parts/GaFilterBaseAutocomplete.vue';
import {useTitle} from '@store/titleStore';
import {VueFire, VueFireAuth} from 'vuefire';
import {firebaseApp} from './firebase';
import 'flag-icons/css/flag-icons.min.css';

const globalOptions = {
  mode: 'international',
  defaultCountry: 'FR',
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
};

Date.prototype.toJSON = function () {
  return moment(this).utc(true).format();
};

const i18n = createI18n({
  locale: navigator.language,
  fallbackLocale: 'fr',
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: {
    fr: fr,
  },
});

moment.locale('fr');
const pinia = createPinia();
const head = createHead();
// Définir un template de titre global
head.push({
  titleTemplate: (title) => {
    if (!title || title.trim() === '') {
      return 'Guestadom';
    }
    const t = i18n.global.t;
    return `${t(title)} | Guestadom`;
  },
});

head.hooks.hook('entries:updated', (head) => {
  for (const [key, valeur] of head.entries) {
    if (valeur.input.title) {
      useTitle().setTitle(valeur.input.title, i18n.global.t);
    }
  }
});

const appVue = createApp(App)
  .use(store)
  .use(pinia)
  .use(i18n)
  .use(VueRecaptchaPlugin, {
    v3SiteKey: import.meta.env.VUE_APP_CAPTCHA_KEY,
  })
  .use(head)
  .use(router)
  .use(LoadingPlugin)
  .use(VueLoaders)
  .use(VSwatches)
  .use(PerfectScrollbarPlugin, {
    componentName: 'perfect-scrollbar',
  })
  .use(VuelidatePlugin)
  .use(VueSplide)
  .use(VueMobileDetection)
  .use(PrimeVue, {
    locale: {
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      monthNames: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Aout',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: "Aujourd'hui",
      weekHeader: 'Wk',
      firstDayOfWeek: 1,
      clear: 'Effacer',
    },
  })
  .use(ToastService)
  .use(FloatingVue, {
    themes: {
      conseil: {
        triggers: ['click'],
        placement: 'top',
        distance: 6,
        autoHide: true,
        // Other options (see the 'Global options' section)
      },
      iframe: {
        triggers: ['click'],
        placement: 'top',
        distance: 6,
        autoHide: true,
        // Other options (see the 'Global options' section)
      },
      information: {
        triggers: ['click'],
        placement: 'top',
        distance: 6,
        autoHide: true,
        // Other options (see the 'Global options' section)
      },
      rules: {
        triggers: ['hover'],
        placement: 'top',
        distance: 6,
        autoHide: true,
        // Other options (see the 'Global options' section)
      },
    },
  })
  .use(ConfirmationService)
  .use(VueTelInput, globalOptions)
  .use(VueFire, {
    // imported above but could also just be created here
    firebaseApp,
    modules: [
      // we will see other modules later on
      VueFireAuth(),
    ],
  }); // Define default global options here (optional)

// Android does not autoHide floating-vue popovers on swipe (a touchstart starting on the reference/popper itself
// does not count as an outside click there, unlike iOS). Force-close them on touchmove so both platforms match.
document.addEventListener('touchmove', () => hideAllPoppers(), {passive: true});

appVue.mixin(VueHeadMixin);
appVue.component('PDialog', Dialog);
appVue.component('DataTable', DataTable);
appVue.component('Message', Message);
appVue.component('Column', Column);
appVue.component('Sidebar', Sidebar);
appVue.component('DataView', DataView);
appVue.component('GaView', GaView);
appVue.component('GaContentView', GaContentView);
appVue.component('GaTabView', GaTabView);
appVue.component('GaTitleMenu', GaTitleMenu);
appVue.component('GaItemTitle', GaItemTitle);
appVue.component('GaReservationSidebar', GaReservationSidebar);
appVue.component('GaCommentSidebar', GaCommentSidebar);
appVue.component('GaReservationFilterPlanning', GaReservationFilterPlanning);
appVue.component('GaReservationFilterList', GaReservationFilterList);
appVue.component('GaAccommodationFilterList', GaAccommodationFilterList);
appVue.component('FacturationHoteOperationsSidebarFilter', FacturationHoteOperationsSidebarFilter);
appVue.component('FacturationHoteConsultationSidebarFilter', FacturationHoteConsultationSidebarFilter);
appVue.component('FacturationVoyageurSidebarFilter', FacturationVoyageurSidebarFilter);
appVue.component('GaOperationsConsultationFilterList', GaOperationsConsultationFilterList);
appVue.component('GaPaymentFilterList', GaPaymentFilterList);
appVue.component('GaThirdPartyAccountFilterList', GaThirdPartyAccountFilterList);
appVue.component('GaRecapitulatifFacturationFilterList', GaRecapitulatifFacturationFilterList);
appVue.component('GaTransactionsFilterList', GaTransactionsFilterList);
appVue.component('GaPartenaireFilterList', GaPartenaireFilterList);
appVue.component('GaHousekeeperFilterList', GaHousekeeperFilterList);
appVue.component('GaPrestataireFilterList', GaPrestataireFilterList);
appVue.component('GaProspectFilterList', GaProspectFilterList);
appVue.component('GaCrmFilterList', GaCrmFilterList);

appVue.component('GaOperationsOwnerChargeFilter', GaOperationsOwnerChargeFilter);
appVue.component('GaCrgConsultationFilter', GaCrgConsultationFilter);
appVue.component('GaCrgListFilter', GaCrgListFilter);
appVue.component('GaCrgPaymentFilter', GaCrgPaymentFilter);
appVue.component('GaCrgHistoriqueFilter', GaCrgHistoriqueFilter);
appVue.component('GaOwnerListFilter', GaOwnerListFilter);
appVue.component('GaClientListFilter', GaClientListFilter);
appVue.component('GaTicketListFilter', GaTicketListFilter);
appVue.component('GaStayRateConsultationFilter', GaStayRateConsultationFilter);
appVue.component('GaStayRateTransfertFilter', GaStayRateTransfertFilter);
appVue.component('GaCancelFilter', GaCancelFilter);
appVue.component('GaEmployeeListFilter', GaEmployeeListFilter);
appVue.component('GaParametrageCommissionFilter', GaParametrageCommissionFilter);
appVue.component('GaLitigeListFilter', GaLitigeListFilter);
appVue.component('GaMandatListFilter', GaMandatListFilter);
appVue.component('GaAvenantListFilter', GaAvenantListFilter);
appVue.component('GaMaintenanceListFilter', GaMaintenanceListFilter);
appVue.component('GaUpsellListFilter', GaUpsellListFilter);
appVue.component('GaMissionPlanningParticipantFilter', GaMissionPlanningParticipantFilter);
appVue.component('GaMissionSuiviFilter', GaMissionSuiviFilter);
appVue.component('GaWaitingOrdersFilter', GaWaitingOrdersFilter);
appVue.component('GaAccommodationExtrasFilter', GaAccommodationExtrasFilter);
appVue.component('GaMissionDashboardFilter', GaMissionDashboardFilter);
appVue.component('GaMissionSuiviPartnerFilter', GaMissionSuiviPartnerFilter);
appVue.component('GaMissionOrderListFilter', GaMissionOrderListFilter);
appVue.component('GaCrgOwnerFilter', GaCrgOwnerFilter);
appVue.component('GaMissionWaitingOrdersSidebar', GaMissionWaitingOrdersSidebar);
appVue.component('GaMissionPlanningAccommodationFilter', GaMissionPlanningAccommodationFilter);
appVue.component('GaReservationLitigeSidebar', GaReservationLitigeSidebar);
appVue.component('GaReservationReclamationSidebar', GaReservationReclamationSidebar);
appVue.component('GaAccommodationMandatUpdateSidebar', GaAccommodationMandatUpdateSidebar);
appVue.component('GaAccommodationReservationFilterList', GaAccommodationReservationFilterList);
appVue.component('GaCommercialFilterList', GaCommercialFilterList);
appVue.component('GaContactDetailsSidebar', GaContactDetailsSidebar);
appVue.component('GaFilterBaseAutocomplete', GaFilterBaseAutocomplete);

appVue.directive('badge', BadgeDirective);

installDatepickerDismissGuard();
appVue.mount('#app');
appVue.config.unwrapInjectedRef = true;

// Ajouter dans la blacklist des domaines d'adresse email personnalisés
addCustomDomains(['guest-adom.co', 'guest-adom.c', 'gmail.co', 'gmail.c']);
